// import '@google/model-viewer';
import '@google/model-viewer/dist/model-viewer';
import Viewer from './components/Viewer';
import "./App.css"
import Webxr from './components/webxr';
import { useEffect, useState } from 'react';
function App() {

  const [chooseDevice, setChooseDevice] = useState()

  useEffect(() => {
    if (navigator.userAgent.match(/Android/i)) {
      setChooseDevice('Android')
    }
    else if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
      setChooseDevice('iPhone')

    }
    else {
      setChooseDevice('desktop')
    }

  }, [])


  return (
    <div className="App">
      {chooseDevice == 'desktop' || chooseDevice == 'iPhone' ?
        <Viewer />
        

        :chooseDevice == 'Android'? <Webxr />
        :null}

    </div>
  );
}

export default App;
